
export const validateArrayObjects = (data) => {

    var isSalesDate = false;
    var isScheduled = false;

    data.forEach((item) => {
        if(data.length === 0){
            isSalesDate = true;
            isScheduled = true;
        } else {
            if (item.vaccine_id === "") {
                isSalesDate = true;
            } else {
                isSalesDate = false;
            }
    
            if (item.scheduled_on === "") {
                isScheduled = true;
            } else {
                isScheduled = false;
            }
        }

    });
    return isSalesDate || isScheduled;
};

export const validateTherapeuticsArrayObjects = (data) => {

    var isGeneric = false;
    // var isBrand = false;
    var isPreparation = false;

    data?.forEach((item) => {
        if(data.length === 0){
            isGeneric = true;
            // isBrand = true;
            isPreparation = true;
        } else {
            if (item.generic === "") {
                isGeneric = true;
            } else {
                isGeneric = false;
            }
    
            // if (item.brand === "") {
            //     isBrand = true;
            // } else {
            //     isBrand = false;
            // }

            if (item.preparation === "") {
                isPreparation = true;
            } else {
                isPreparation = false;
            }
        }

    });
    return isGeneric || isPreparation;
};
